import DailyWind from "./DailyWind";

export default DailyWind;